import { initComponent } from './core/init-component.js'
import { Swiper } from 'swiper'
import { Navigation } from 'swiper/modules'

class ProductRecommendations extends HTMLElement {
  constructor() {
    super()

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('product-recommendations')
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
            this.initSwiper()
          }
        })
        .catch((e) => {
          console.error(e)
        })
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this)
  }

  initSwiper() {
    const slider = this.querySelector('.js-product-recommendations-swiper')
    if (!slider) return

    const prevEl = this.querySelector('.js-slider-prev')
    const nextEl = this.querySelector('.js-slider-next')

    new Swiper(slider, {
      modules: [Navigation],
      slidesPerView: 1.25,
      spaceBetween: 8,
      slidesPerGroup: 1,
      freeMode: false,
      navigation: {
        prevEl,
        nextEl
      },
      breakpoints: {
        768: {
          slidesPerView: 1.5,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 16,
        }
      }
    })
  }
}

customElements.define('product-recommendations', ProductRecommendations)

initComponent('.js-product-recommendations', section => {
  const slider = section.querySelector('.js-product-recommendations-swiper')
  const prevEl = section.querySelector('.js-slider-prev')
  const nextEl = section.querySelector('.js-slider-next')

  const swiper = new Swiper(slider, {
    modules: [Navigation],
    slidesPerView: 1.25,
    spaceBetween: 8,
    slidesPerGroup: 1,
    freeMode: false,
    navigation: {
      prevEl,
      nextEl
    },
    breakpoints: {
      768: {
        slidesPerView: 1.5,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16,
      }
    }
  })

  return {
    unload() {
      swiper.destroy()
    }
  }
})